import styled from '@emotion/styled'
import { Locale, Translation } from 'locale'
import React, { useState, useEffect } from 'react'

const PreloadingTradesWrapper = styled.div`
  flex: 1;
  padding: 0 25px;

  span {
    opacity: 0;
    transition: opacity 120ms ease-out;
  }

  span.active {
    opacity: 1;
  }
`

export const PreloadingTradesMessage: React.FC = () => {
  const [loaded, setLoaded] = useState(false)
  useEffect(() => {
    setTimeout(() => setLoaded(true), 750)
  })
  return (
    <PreloadingTradesWrapper>
      <span className={loaded ? 'active' : ''}>{Locale.translate(Translation.SC_MTE_UPLOAD_PRELOADING_TRADES)}</span>
    </PreloadingTradesWrapper>
  )
}
